import React from 'react';
import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import { ClassesNew } from 'components';

export const ClassesPageNew = props => {
  return (
    <HeaderFooterLayout >
      <ClassesNew {...props} />
    </HeaderFooterLayout>
  );
};
